import Device from "../../devices/device";
import DeviceStorage from "../../components/DeviceStorage/DeviceStorage";
import store from "../../store";
import NewRelic from "../trackers/NewRelic";

export const TIMEOUT = 'timeout';
export const CRASH = 'crash';
export const RENDER_FAILURE = 'render_failure';
export const DATA_LOAD_FAILURE = 'data_load_failure';
export const PROFILES = 'profiles';
export const LANDING_NEWRELIC = 'landing';
export const HOMEUSER = 'homeuser';
export const HOME_CAROUSEL = 'home_carousel';

const errorTypes = {
  [TIMEOUT] : TIMEOUT,
  [CRASH]: CRASH,
  [RENDER_FAILURE]: RENDER_FAILURE,
  [DATA_LOAD_FAILURE]: DATA_LOAD_FAILURE
}
const destinations = {
  [PROFILES]: PROFILES,
  [LANDING_NEWRELIC]: LANDING_NEWRELIC,
  [HOMEUSER]: HOME_CAROUSEL
}

const  generateUUID = (currentChar) => {
  const randomHexDigit = (Math.random() * 16) | 0;
  const finalHexValue = currentChar === 'x' ? randomHexDigit : (randomHexDigit & 0x3) | 0x8;
  return finalHexValue.toString(16);
}

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(
      /[xy]/g,
      function (currentChar) { return generateUUID(currentChar) } );
}

const attributesNewRelicOk = {
  eventType:"AppStartupMetrics",
  startupDestination: "",
  userInteractionReady: 0,
  platform: Device.getDevice().getPlatform(),
  language: "javascript",
  deviceType: Device.getDevice().config.device_type,
  appVersion: DeviceStorage.getItem("appVersion") || "",
  sessionId: getUUID() || ""
}

const attributesNewRelicError = {
  eventType:"AppStartupMetricsError",
  errorType: ""
}

const getAppStartTime = () => {
  const appStartTimeStorage = DeviceStorage.getItem("appStartTime");
  return appStartTimeStorage && typeof appStartTimeStorage === 'string'
    ? parseInt(appStartTimeStorage)
    : 0;
}

const initializeAppStart = () => {
  return DeviceStorage.getItem("appStart") || "false";
}

const getRegion = () => {
  return DeviceStorage.getItem("region") || ''
}

export const sendLoadAppToNewRelic = (display = null) => {
  const appStartTime = getAppStartTime();
  const region = getRegion();
  const appStart = initializeAppStart();

  attributesNewRelicOk.startupDestination = display ? destinations[display] : "";
  attributesNewRelicOk.userInteractionReady = Date.now() - appStartTime;

  appStart === 'true' && NewRelic.recordCustomEvent("AppStartupMetrics", attributesNewRelicOk)
  attributesNewRelicOk.region = region
  appStart === 'true' && NewRelic.recordCustomEvent("AppStartupMetrics", attributesNewRelicOk)
  localStorage.setItem("appStart", "false");
};

export const sendLoadAppErrorToNewRelic = (errorType = null) => {
  attributesNewRelicError.errorType = errorType ? errorTypes[errorType] : "";
  const region = getRegion();
  const appStart = initializeAppStart();

  appStart === 'true' && NewRelic.recordCustomEvent("AppStartupMetricsError", attributesNewRelicError);
  attributesNewRelicError.region = region
  appStart === 'true' && NewRelic.recordCustomEvent("AppStartupMetricsError", attributesNewRelicError);
  localStorage.setItem("appStart", "false");

};



// WEBPACK FOOTER //
// ./src/utils/newRelic_loadApp/newRelic-load-app.js